import styled from 'styled-components'
import Step from './step'
import data from './steps.json'

const ScholarshipStepsStyled = styled.div`
  counter-reset: steps;
  .step-container {
    counter-increment: steps;
    &::before {
      content: "0"counter(steps);
      opacity: 0.1;
      position: absolute;
      top: -10px;
      left: 0;
      font-size: 96px;
      line-height: 117px;
      font-weight: bold;
    }
  }
  @media(min-width: 1024px) {
    .step-container::before {
      top: -24%;
    }
  }
  @media(min-width: 1150px) {
    .step-container::before {
      font-size: 200px;
      line-height: 240px;
    }
  }
  @media(min-width: 1300px) {
    .step-container::before {
      top: 0px;
    }
  }
`

function ScholarshipSteps() {
  return (
    <ScholarshipStepsStyled>
      {data.map((stepData) => (
        <Step key={stepData.id} {...stepData} />
      ))}
    </ScholarshipStepsStyled>
  )
}

export default ScholarshipSteps
